import { HttpClient, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from './config.service';
import { LogService } from './log.service';
import { Observable, throwError } from 'rxjs';
import * as FileSaver from 'file-saver';
import { Lookup } from '@interfaces/lookup';

export class CommonService {

    constructor(protected http:HttpClient, protected configService:ConfigService,protected logger: LogService) { }
    
    protected baseUrl:string = this.configService.getServer();
    protected fabricApiUrl:string = this.configService.getFabricApiUrl();
    protected langId:string = localStorage.getItem("langId");

    // used for token revoke requests
    protected extractStatus(res: Response) {
        let body = res.status;
        return body;
    }

    protected extractData(res: HttpResponse<any>):any {
        let body;
        if (res instanceof HttpResponse) {
            //trick to handle json parse errors in empty responses
            if(res.body) {
                try{
                    body = JSON.parse(res.body);
                } catch (e){
                    body = res.body;
                }
            }
        } else {
            body = res;
        }
        return body;
    }

    public saveData(res: any):any {
        this.configService.getIsSessionStorage() ? sessionStorage.setItem('access_token', res.access_token) : localStorage.setItem('access_token', res.access_token);
        return res;
    }


    protected getActiveLang() {
        return localStorage.getItem('langId');
    }

    public saveToStorageWithName(res: Response, name:string) {
        localStorage.setItem(name, JSON.stringify(res));
    }

    public getLkpFromStorageAsJSON(name:string, required?:boolean):Lookup[]{
        let body = JSON.parse(localStorage.getItem(name+'_'+this.getActiveLang()));
        if(!required){
            if (Array.isArray(body)){
                body.unshift({id:" ", text : " "});
            }
        }
        return body;
    }

    public getFromStorageAsJSON(name:string, lang = true){
        return JSON.parse(localStorage.getItem(name + (( lang )? '_' + this.getActiveLang() : '')));
    }

    public saveToStorage(key:string, value:string){
        this.configService.getIsSessionStorage() ? sessionStorage.setItem(key, value) : localStorage.setItem(key, value);
    }

    public getFromStorage(key:string):string{
        return this.configService.getIsSessionStorage() ? sessionStorage.getItem(key) : localStorage.getItem(key);
    }

    public clearStorages(){
        let langId = this.getFromStorage('langId') ? this.getFromStorage('langId') : this.configService.getLangDefault().toString();
        localStorage.clear();
        sessionStorage.clear();
        this.saveToStorage('langId', langId);
    }

    public setPostParams(body:any):any{

        let requestHeaders = new HttpHeaders({'Content-Type': 'application/json'});

        let options = {
            method  :   'POST',
            body    :   JSON.stringify(body),
            headers :   requestHeaders
        }

        return options;
    }
    public extractTxt(res: HttpResponse<any>) {
        let body:any;
        if (res instanceof HttpResponse) {
            body = res.body;
        } else {
            body = res;
        }
        let blob = new Blob([body], { type: 'text/csv' });

        let filename  = (res.headers.get('X-Attachment-Name') || 'results') + '.txt';
        FileSaver.saveAs(blob, filename);


        /*
        //way without Filesaver module
        //only works in chrome

        let url= window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.download = "results.txt";
        a.href = url;
        a.textContent = "";
        //a.click();
        //if the click() function dosen't work you can try using onclick() fucntion like this
        //a.onclick();
        return body;
        */
    }

    public extractPdf(res: HttpResponse<any>) {
        let body:any;
        if (res instanceof HttpResponse) {
            body = res.body;
        } else {
            body = res;
        }
        let blob = new Blob([body], { type: 'application/pdf' });

        let filename  = (res.headers.get('X-Attachment-Name') || 'results') + '.pdf';
        FileSaver.saveAs(blob, filename);

        /*
        //way without Filesaver module
        //only works in chrome
        
        
        let url= window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.download = "results.pdf";
        a.href = url;
        a.textContent = "";
        a.click();
        //if the click() function dosen't work you can try using onclick() fucntion like this
        //a.onclick();
        return body;
        */
    }

    /**
     * Only allow console.* (not this.logger) here 
     */
     public handleError (errorResponse: HttpErrorResponse | any) {
        let errMsg: string;
        //uncomment to display full stacktrace
        console.error(errorResponse);

        if (errorResponse instanceof HttpErrorResponse) {
          errMsg = (errorResponse.error.data != null) ? errorResponse.error.data.message : errorResponse.error.message;
          errMsg = (errMsg === undefined) ? JSON.parse(localStorage.getItem('visualsArray' +  '_' + 
                                            localStorage.getItem('langId') ))['generic'][errorResponse.error.error] : errMsg;
          
        } else {
          errMsg = errorResponse.message ? errorResponse.message : errorResponse.toString();
        }

        LogService.emitAlert({
          type: 'error',
          body: errMsg
        });

        return throwError(errorResponse.error);
    }

    public async handleBlobError(errObj: HttpErrorResponse | any){
        let errorResponse = JSON.parse(await errObj.error.text());
        return this.handleError(errorResponse);
    }

        /**
     * Parse object(JSON) to standard HTTP:GET param format
     * 
     * @param params { 0-n?:any }
     */
         public urlParamsToString(params: any) {

            let urlParams = "";
            Object.keys(params).forEach((param, index) => {
                urlParams += param + "=" + params[param] + "&";
            });
    
            return urlParams + 'langId=' + localStorage.getItem("langId");
        }
    
        public setGetParams(body:any):any{

            let requestHeaders = new HttpHeaders({
                'Content-Type': 'application/json'
            });
    
            let options = {
                method  :   'GET',
                params  :   /*JSON.stringify(*/body/*)*/,
                headers :   requestHeaders
            };
    
            return options;
        }

}